






















import { Component, Vue, Prop } from 'vue-property-decorator'
import { UnitDevicePointData } from '@/api/heritageUnit/unitDevice'
import { newGuid } from '@/configs/functions'
import DevicePointView from './view.vue'
//import ViewLink from '@/components/viewLink.vue'

@Component({
  components: {  DevicePointView }
})
export default class DevicePointsView extends Vue {
  public name = 'DevicePointsView'
  @Prop({ default: null })
  public dataList: UnitDevicePointData[] = []

}
